import './claim-type.css';
import { InputField } from "../../../../../InputFields/InputField";
import { useState } from 'react';
import { formatMoney } from '../../../../../../utils/claimUtil';

interface ClaimInfo {
    setStepOneComplete?: any;
    claimType?: string;
    policyNum?: string;
    // story-1454 - change disabled
    // claimRepairCost?: string;
    // setClaimRepairCost?: any;
}

const TheftClaimStepOne = ({policyNum, claimType,
    // story-1454 - change disabled 
    // claimRepairCost, 
    // setClaimRepairCost
}: ClaimInfo) => {

    // story-1454 - change disabled
    // const handleCostChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    //     const value = e.target.value;
    //     const formatted = formatMoney(value);
    //     setClaimRepairCost(formatted);
    // };

    return (
        <div className="theft-claim__container">
            <p className='theft-claim__title'> Please provide the policy number for which you are making a claim on.</p>
            <div className='theft-claim__field-group'>
                <p className="theft-claim__label"> Claim Type </p>
                <InputField
                    type='input'
                    value={claimType}
                />
            </div>

            {/* story-1454 - change disabled */}
            {/* <div className='theft-claim__field-group'> */}
            <div>
                <p className="theft-claim__label"> Policy Number </p>
                <InputField
                    type='input'
                    value={policyNum}
                />
            </div>

            {/* story-1454 - change disabled */}
            {/* <div className='theft-claim__field-group repair-cost'>
                <p className="theft-claim__label"> Statement Repair Cost </p>
                <InputField
                    type='input'
                    value={claimRepairCost}
                    onChange={handleCostChange}
                    placeholder="$ 0.00"
                />
            </div> */}
        </div>
    );
}

export default TheftClaimStepOne;